export default __webpack_public_path__ + "media/images/logos/FINMASONlogo_transparentbg_crop-cafbbe1fdd7c2aed30b76cf0fd27c5fd.png";